import { cloneDeep } from "lodash";

import { Role } from "@/acl/roles";
import { GenericProductCards } from "@/assets/constants/analysisCards";
import { EventDate, GLOBAL_EVENTS } from "@/assets/constants/eventsDates";
import { UpdateFrequency } from "@/assets/constants/frequencies";
import { STANDARD_PERF_STATS_WITHOUT_BENCHMARK } from "@/assets/constants/perfStats";
import { STANDARD_ZOOM_BUTTONS } from "@/assets/constants/zoomButtons";
import exports from "@/assets/scss/exports.module.scss";

const ORG_COLOR = exports["colors-primary"];
const MODEL_ALLOWED_ROLES = [Role.admin, Role.superAdmin, Role.viewer];

// ******---------- SMARTF EQUITY CH ----------*****
const smartfEquityChA = {
  productId: "smartf-equity-ch-a",
  storeModule: "smartfEquityChA",
  productName: "smartF® - Equity Switzerland Enhanced A",
  productShortName: "smartF® - Equity Switzerland Enhanced",
  productColor: ORG_COLOR,
  productShareClassRoot: "smartf-equity-ch",
  isDefaultShareClass: true,
  live: {
    mode: "live",
    updateFrequency: UpdateFrequency.daily,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.outperformance,
      GenericProductCards.drawdowns,
      GenericProductCards.volatility,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  factsheet: {
    needLoginToSee: false,
  },
};

const smartfEquityChB = cloneDeep(smartfEquityChA);
smartfEquityChB.productId = "smartf-equity-ch-b";
smartfEquityChB.storeModule = "smartfEquityChB";
smartfEquityChB.productName = "smartF® - Equity Switzerland Enhanced B";
smartfEquityChB.isDefaultShareClass = false;

const smartfEquityChI = cloneDeep(smartfEquityChA);
smartfEquityChI.productId = "smartf-equity-ch-i";
smartfEquityChI.storeModule = "smartfEquityChI";
smartfEquityChI.productName = "smartF® - Equity Switzerland Enhanced I";
smartfEquityChI.isDefaultShareClass = false;

const smartfEquityChSx = cloneDeep(smartfEquityChA);
smartfEquityChSx.productId = "smartf-equity-ch-sx";
smartfEquityChSx.storeModule = "smartfEquityChSx";
smartfEquityChSx.productName = "smartF® - Equity Switzerland Enhanced SX";
smartfEquityChSx.isDefaultShareClass = false;

const smartfEquityChZx = cloneDeep(smartfEquityChA);
smartfEquityChZx.productId = "smartf-equity-ch-zx";
smartfEquityChZx.storeModule = "smartfEquityChZx";
smartfEquityChZx.productName = "smartF® - Equity Switzerland Enhanced ZX";
smartfEquityChZx.isDefaultShareClass = false;

// ******---------- SMARTF MODELL EQUITY CH ----------*****
const smartfModellEquityChZx = {
  productId: "smartf-modell-equity-ch-zx",
  storeModule: "smartfModellEquityChZx",
  productName: "smartF® Model - Equity Switzerland",
  productColor: ORG_COLOR,
  oldDataEndDate: "2024-12-20",
  oldDataHighlightColor: "#ececec",
  allowedRoles: MODEL_ALLOWED_ROLES,
  live: {
    mode: "live",
    updateFrequency: UpdateFrequency.daily,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.outperformance,
      GenericProductCards.drawdowns,
      GenericProductCards.volatility,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS.concat([
      EventDate.winvestModelSimulation,
      EventDate.winvestInterestRateShock,
    ]),
  },
  factsheet: {},
};

export const WINVEST_PRODUCTS_DETAILS = [
  smartfEquityChA,
  smartfEquityChB,
  smartfEquityChI,
  smartfEquityChSx,
  smartfEquityChZx,
  smartfModellEquityChZx,
];

export const WINVEST_PRODUCTS = WINVEST_PRODUCTS_DETAILS.map((details) => details.storeModule);
